<template>
    <!-- 商品分类 -->
    <div class="commodityClassify">
        <div class="table">
            <div class="table-operation">
                <el-button type="warning" icon="el-icon-plus"
                    @click.stop="dialogVisible = true, dialogType = 1, form = {}">新增</el-button>
                <el-button type="info" icon="el-icon-refresh-left" @click.stop="loading = true, getList()"></el-button>
            </div>
            <Table :data="tableData" :total="total" v-loading="loading"
                @size-change="pageNum = $event, loading = true, getList()"
                @current-change="page = $event, loading = true, getList()">
                <el-table-column label="分类名称" prop="title" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="160">
                    <template slot-scope="scope">
                        <el-button type="warning" size="mini"
                            @click.stop="dialogVisible = true, dialogType = 2, openDialog(scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" @click.stop="removeFn(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </Table>
        </div>
        <!-- 新增 -->
        <el-dialog :title="dialogType == 1 ? '新增' : '编辑'" :visible.sync="dialogVisible" :close-on-click-modal="false"
            v-el-drag-dialog width="30%">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="分类名称" required>
                    <el-input v-model="form.title" placeholder="请输入分类名称"></el-input>
                </el-form-item>
                <el-form-item label="商品排序">
                    <el-input v-model="form.sort" placeholder="请输入商品排序"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click.stop="dialogVisible = false">取 消</el-button>
                <el-button type="warning" @click.stop="confirmFn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
    
<script>
export default {
    data() {
        return {
            tableData: [],
            loading: true,
            page: 1,
            pageNum: 10,
            total: 0,
            // 新增、编辑弹窗
            dialogType: 1,//1新增2编辑
            dialogVisible: false,
            form: {
                title: '',
                sort: 0
            }
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            this.$http.post(`/erp/v1/goods_category/lst`, {
                page: this.page,
                pageNum: this.pageNum,
            }).then((res) => {
                const { code, data, msg } = res.data
                this.loading = false
                if (code == 200) {
                    this.tableData = data.rows
                    this.total = data.total
                } else {
                    this.$message.error(msg);
                }
            });
        },
        // 编辑弹窗
        openDialog(item) {
            this.form.cate_id = item.id
            this.form.title = item.title
            this.form.sort = item.sort
        },
        // 确定
        confirmFn() {
            if (!this.form.title) {
                this.$message.error('请输入分类名称');
                return
            }
            let url = this.dialogType == 1 ? '/erp/v1/goods_category/add' : '/erp/v1/goods_category/modify'
            this.$http.post(`${url}`, this.form).then((res) => {
                const { code, msg } = res.data
                if (code == 200) {
                    this.$message.success(msg);
                    this.dialogVisible = false
                    this.getList()
                } else {
                    this.$message.error(msg);
                }
            });
        },
        // 删除
        removeFn(item) {
            this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post(`/erp/v1/goods_category/delete`, {
                    category_ids: item.id
                }).then((res) => {
                    const { code, msg } = res.data
                    if (code == 200) {
                        this.$message.success(msg);
                        this.getList()
                    } else {
                        this.$message.error(msg);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        }
    },
}
</script>
    
<style lang="scss" scoped></style>